<template>
  <div >
    <el-upload
      :action="baseURL+'/product-service/file/uploadFile'"
      :multiple="false"
      :headers="dataObj"
      :show-file-list="showFileList"
      :file-list="fileList"
      :on-remove="handleRemove"
      :on-success="handleUploadSuccess"
      :accept="accept"
      :on-preview="handlePreview">
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="fileList[0].url" alt="">
    </el-dialog>
  </div>
</template>
<script>
import { policy } from '@/api/Persona/index' ;

export default {
  name: 'videoUpload',
  props: {
      value: String,
      accept: {
          type: String,
          default: ".doc,.docx,.pdf,.wmv,.asf,.asx,.mp4,.mov,.m4v,.avi",
      },
      validateWidth: {
          type: Number,
      },
      validateHeight: {
          type: Number,
      },
      minWidth: {
          type: Number,
      },
      maxWidth: {
          type: Number,
      },
      minHeight: {
          type: Number,
      },
      maxHeight: {
          type: Number,
      },
  },
  computed: {
      imageUrl() {
          return this.value;
      },
      imageName() {
          if (this.value != null && this.value !== '') {
              return this.value.substr(this.value.lastIndexOf("/") + 1);
          } else {
              return null;
          }
      },
      fileList() {
          return [{
              name: this.imageName,
              url: this.imageUrl
          }]
      },
      showFileList: {
          get: function () {
              return this.value !== null && this.value !== ''&& this.value!==undefined;
          },
          set: function (newValue) {
          }
      },
      dataObj(){
          return { Authorization: localStorage.getItem('token')}
      }
  },
  data() {
      return {
          dialogVisible: false,
          // baseURL : BASE_API,
          baseURL : process.env.VUE_APP_API_PREFIX,
      };
  },
  methods: {
      // ...mapActions("tool", ["policy"]),
      emitInput(val) {
          this.$emit('input', val)
      },
      handleRemove(file, fileList) {
          this.emitInput('');
      },
      handlePreview(file) {
          this.dialogVisible = true;
      },
      beforeUpload(file) {
          // console.log(this.types, 'types');
          let _self = this;
          return new Promise((resolve, reject) => {
              policy().then(response => {
                  console.log(response, 'response')
                  console.log(file, 'file');
                  // _self.dataObj.type = this.types
                  resolve(true)
              }).catch(err => {
                  console.log(err)
                  reject(false)
              })
          })
      },
      handleUploadSuccess(res, file) {
          console.log(res, 'res0');
          console.log(file, 'file0');
          this.showFileList = true;
          this.fileList.pop();
          this.fileList.push({name: file.name, url: file.response.data});
          this.emitInput(this.fileList[0].url);
          console.log(this.fileList)
      },
  }
}
</script>
<style lang="scss">
</style>


